import $ from "jquery";

let timeout = null;

$(".js-typeahead-input").on("input", (e) => {
  const searchInput = $(e.currentTarget);
  const suggestionsList = searchInput
    .parents("form")
    .find(".js-typeahead-suggestions");

  clearTimeout(timeout);

  timeout = setTimeout(() => {
    getTypeaheadResults(searchInput.val(), suggestionsList);
  }, 500);
});

$("html").click((e) => {
  if (!$(e.target).hasClass("js-typeahead")) {
    $(".js-typeahead-suggestions").removeClass("open");
  }
});

const getTypeaheadResults = (searchValue, suggestionsList) => {
  const data = {
    // @ts-ignore: Unreachable code error
    Site: baseQuery.siteId,
    page: 1,
    pageSize: 7,
    // @ts-ignore: Unreachable code error
    IsMemberSearch: baseQuery.memberSearch,
    query: searchValue,
    filterBy: [""],
  };

  $.ajax({
    cache: false,
    contentType: "application/json",
    data: JSON.stringify(data),
    type: "POST",
    url: "/umbraco/api/SearchApi/TypeAhead",
    success(result) {
      if (result.length > 0) {
        suggestionsList.addClass("open");
        let suggestion = "";

        $.each(result, (i, item) => {
          suggestion +=
            '<li><a href="' + item.url + '">' + item.title + "</a></li>";
        });
        suggestionsList.html(suggestion);
      }
    },
  });
};
